/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "propolis-hosting-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d1goe72i9ld6rn.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-east-1:de9ba81f-8758-4fb5-8829-388cf4ff1802",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_eDpPaEQwL",
    "aws_user_pools_web_client_id": "7qqkcrcaipjffek05f7n6aj5fb",
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_login_mechanism": [
        "EMAIL"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    }
};


export default awsmobile;
